import { useEffect, useState } from 'react';

import { checkIsIframed } from '../helpers';

const useIsIframed = () => {
  const [isIframed, setIsIframed] = useState(false);

  useEffect(() => {
    if (checkIsIframed()) {
      setIsIframed(true);
    }
  }, []);

  return isIframed;
};

export default useIsIframed;
